exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".-Modal-module-backdrop-hVxgY{position:fixed;top:0px;bottom:0px;left:0px;right:0px;background-color:rgba(0,0,0,.75);padding:16px;z-index:250;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.-Modal-module-backdrop-hVxgY .-Modal-module-modal-FqeFw{width:100%;max-width:350px}", ""]);

// exports
exports.locals = {
	"backdrop": "-Modal-module-backdrop-hVxgY",
	"modal": "-Modal-module-modal-FqeFw"
};